export default __webpack_public_path__ + "e8f0fca6a54acc47a14e7fd03a2b3329.png";